import React, { Component } from "react";
import Card from "../../components/Card";
import ScrollToTop from "../../components/utils/ScrollToTop";
import Image from "../../components/Image";
import imageOfficeWorking from "../../images/office-working.png";
import { recordSignupTermination } from "../../utils/flowActivityUtils";

class BuyingMoneySorryPage extends Component {
  componentDidMount() {
    recordSignupTermination(this.props.leadId, this.displayRejectionReason());
  }

  displayRejectionReason() {
    if (this.props.purchaseMoneySources?.highRiskCountry) {
      return "money from high risk country";
    }
    if (this.props.purchaseMoneySources?.usingCrypto) {
      return "using crypto";
    }
  }

  render() {
    return (
      <React.Fragment>
        <ScrollToTop />
        <Card title="We’re unable to help with this purchase" removeTopPadding>
          <p>All law firms are required by regulation to verify the source of funds used in a property purchase.</p>
          <p>
            Due to the way our verification processes currently work, we’re unable to accept funds from certain
            countries or from cryptocurrency — even where those funds are now held in a UK bank account.
          </p>
          <p>
            We understand this is frustrating, and we’re sorry we can’t help. Another conveyancing firm may be able to
            assist you with the additional verification steps involved.
          </p>
        </Card>
        <Image src={imageOfficeWorking} fullWidth />
      </React.Fragment>
    );
  }
}

export default BuyingMoneySorryPage;
